var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transaction-view',{attrs:{"transaction":_vm.transaction}},[_c('div',[_vm._v(_vm._s(_vm.$t("Post")))]),_c('div',{staticClass:"transaction-item__name"},[_vm._v(" "+_vm._s(_vm.resolveUserName(_vm.transaction.details.opponent))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }